export async function delegateArtboardUpdate(type, key, opts = {}) {
  const Collection = this.getCanvasCollection()
  const componentExists = Boolean(Collection?.context?.[type]?.[key])
  if (!componentExists) {
    await this.call('createCanvasItem', type, key, opts)
  } else if (this.inOnCurrentCanvasPage(type, key)) {
    await this.call('updateCanvasItem', type, key, opts)
  } else {
    await this.refreshComponentsWhereReferencedOnCanvas(key)
  }
}

export async function delegateExecutableUpdate(type, key, opts = {}) {
  const Collection = this.getCanvasCollection()
  const executableExists = Boolean(Collection.context[type][key])
  if (!executableExists) {
    await this.call('createCanvasItem', type, key, opts)
  } else {
    await this.call('updateCanvasItem', type, key, opts)
  }
}

export async function delegateSingleUpdate(type, key, opts = {}) {
  if (this.call('hasArtboard', type)) {
    await this.call('delegateArtboardUpdate', type, key, opts)
  } else if (this.call('hasExecutable', type)) {
    await this.call('delegateExecutableUpdate', type, key, opts)
  }

  this.addIfPlatformProject(type, key)
}

export async function delegateTypeUpdate(type, typeData, opts = {}) {
  if (!this.hasItems(type)) {
    return
  }
  for (const key in typeData) {
    await this.call('delegateSingleUpdate', type, key, opts)
  }
}

export async function delegateUpdates(changes, opts = {}) {
  const hasSchema = Boolean(changes.schema)
  const hasDataTypes = Object.keys(changes).some((type) => this.hasItems(type))

  if (!hasDataTypes && hasSchema) changes = changes.schema

  for (const type in changes) {
    const typeData = changes[type]
    await this.call('delegateTypeUpdate', type, typeData, {
      changes,
      ...opts
    })
  }
}
